module.exports = __webpack_public_path__ + "static/img/oneLineService.0aeffaf6.png";